import axios from 'axios';

import { API_BASE_URL } from '../../_shared';

import { ENUMS_VIDEO } from '../constants';

const axiosClient = axios.create({
	withCredentials: true,
	baseURL: API_BASE_URL.VIDEOS,
});

/**
 * Fetches a video based on ID and scope.
 *
 * @param {String} videoId   The ID of the video to fetch
 * @param {String} scope     The scope for the request
 * @param {String} scopeId   The scope id for the request
 *
 * @returns {Promise<AxiosResponse>} Promise containing response from request
 */
export const fetchVideo = (videoId, scope, scopeId) => {

	const params = {
		scope,
		scope_id: scopeId,
	};

	return axiosClient.get(`/${videoId}`, { params });

};

/**
 * Creates a new video for a Mux static video which is ready for upload.
 * Returns the video which contains an upload URL.
 *
 * @param {String} scope The scope for the request
 * @param {String} scopeId The scope id for the request
 * @param {String} [options] Additional upload configuration options
 * @param {String} [options.generated_subtitles_language]
 * The language code used to automatically generate closed captions
 *
 * @returns {Promise<AxiosResponse>} Promise containing response from request
 */
export const createMuxStaticUpload = (scope, scopeId, options = {}) => {

	const body = {
		provider: ENUMS_VIDEO.PROVIDER.MUX,
		scope,
		scope_id: scopeId,
		...options,
	};

	return axiosClient.post('/mux/upload', body);

};

/**
 * Updates the master access for a video.
 *
 * @param {Object} video     The updated video data
 *
 * @returns {Promise<AxiosResponse>} Promise containing response from request
 */

export const updateMasterAccess = (video) => {
	return axiosClient.patch(`/${video.id}/master-access`, video);
};

/**
 * Updates an existing video.
 *
 * @param {Object} video     The updated video data
 *
 * @returns {Promise<AxiosResponse>} Promise containing response from request
 */
export const updateVideo = (video) => {
	return axiosClient.patch(`/${video.id}`, video);
};

/**
 * Deletes a video.
 *
 * @param {String} videoId   The ID of the video to fetch
 * @param {String} scope     The scope for the request
 * @param {String} scopeId   The scope id for the request
 *
 * @returns {Promise<AxiosResponse>} Promise containing response from request
 */
export const deleteVideo = (videoId, scope, scopeId) => {

	const params = {
		scope,
		scope_id: scopeId,
	};

	return axiosClient.delete(`/${videoId}`, { params });

};
